"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const shared_module_1 = require("../common/shared.module");
const devextreme_angular_1 = require("devextreme-angular");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const viewGlossary_service_1 = require("./services/viewGlossary.service");
const viewGlossary_component_1 = require("./components/viewGlossary.component");
const viewGlossary_states_1 = require("./viewGlossary.states");
const i0 = require("@angular/core");
const i1 = require("@uirouter/angular-hybrid");
class GlossaryModule {
}
exports.GlossaryModule = GlossaryModule;
GlossaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GlossaryModule });
GlossaryModule.ɵinj = i0.ɵɵdefineInjector({ factory: function GlossaryModule_Factory(t) { return new (t || GlossaryModule)(); }, providers: [viewGlossary_service_1.ViewGlossaryService], imports: [[
            shared_module_1.SharedModule,
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            devextreme_angular_1.DxFormModule,
            devextreme_angular_1.DxButtonModule,
            devextreme_angular_1.DxDataGridModule,
            devextreme_angular_1.DxDateBoxModule,
            devextreme_angular_1.DxDropDownBoxModule,
            devextreme_angular_1.DxListModule,
            devextreme_angular_1.DxValidatorModule,
            angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: viewGlossary_states_1.states })
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GlossaryModule, { declarations: [viewGlossary_component_1.ViewGlossaryComponent], imports: [shared_module_1.SharedModule,
        platform_browser_1.BrowserModule,
        forms_1.FormsModule,
        devextreme_angular_1.DxFormModule,
        devextreme_angular_1.DxButtonModule,
        devextreme_angular_1.DxDataGridModule,
        devextreme_angular_1.DxDateBoxModule,
        devextreme_angular_1.DxDropDownBoxModule,
        devextreme_angular_1.DxListModule,
        devextreme_angular_1.DxValidatorModule, i1.UIRouterUpgradeModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GlossaryModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    shared_module_1.SharedModule,
                    platform_browser_1.BrowserModule,
                    forms_1.FormsModule,
                    devextreme_angular_1.DxFormModule,
                    devextreme_angular_1.DxButtonModule,
                    devextreme_angular_1.DxDataGridModule,
                    devextreme_angular_1.DxDateBoxModule,
                    devextreme_angular_1.DxDropDownBoxModule,
                    devextreme_angular_1.DxListModule,
                    devextreme_angular_1.DxValidatorModule,
                    angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: viewGlossary_states_1.states })
                ],
                providers: [viewGlossary_service_1.ViewGlossaryService],
                declarations: [
                    viewGlossary_component_1.ViewGlossaryComponent
                ]
            }]
    }], null, null); })();
